import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Grupo, ISgrupo } from "../../types/grupo/Grupo";
import { Panel } from "primereact/panel";
import { GrupoForm } from "./GrupoForm";
import { useCreateGrupo1Mutation, useCreateGrupoMutation, useGetGrupoQuery, useUpdateGrupoMutation } from "./grupoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useParams } from "react-router-dom";
import { errorMonitor } from "events";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";



export const GrupoEdit = () => {

    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
   
   
    const [updateGrupo, status] = useUpdateGrupoMutation();
   
   
    const id = useParams().id || "";
    const { data, isFetching, error } = useGetGrupoQuery(id);
    const [grupo, setGrupo] = useState<Grupo>(ISgrupo);


    useEffect(() => {
        if (data) {
            setGrupo(data);
        }  else if (error) {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }  else if (isFetching) {
            enqueueSnackbar("Buscando registro...", { variant: "info" })
        }  else {
            enqueueSnackbar("Registro não encontrado!", { variant: "error" })
        }      
    },[data,error,isFetching])



    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setGrupo((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await updateGrupo(grupo);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não alterado!", { variant: "error" })
            const erroReturn: string  = errorFormat(status);          
            enqueueSnackbar(erroReturn, {variant: "error"})
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro alterado com sucesso!", { variant: "success" })
            navigate(configUrls.GRUPO_ACOMPANHAMENTO_LIST);   
        }
    }, [status]);


    return (
        <>
            <Paper >

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Grupos de Acompanhamento - Edição
                </Typography>



                <GrupoForm
                    data={grupo}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/